import KPITable from "@/components/KPITable"
import { ScrollArea, ScrollBar } from "@/components/ui/scroll-area"

import FlowChart from "./FlowChart"
import GasChart from "./GasChart"
import KPIChartGroup from "./KPIChartGroup"
import RollingChart from "./RollingChart"

import type { DashboardConfig } from "../types/dashboardTypes"

export default function Dashboard({ config }: { config: DashboardConfig }) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-4">
      {config.kpiTable && (
        <div className="col-span-2 md:col-span-2 xl:col-span-2 gap-4 rounded-md shadow-sm border flex">
          <ScrollArea type="always" className="w-1 flex-1">
            <ScrollBar orientation="horizontal" className="w-full" />
            <KPITable
              request={config.kpiTable.request}
              showAverage={false}
              title="Monthly Gas Metrics"
              paddingArray={config.kpiTable.paddingArray}
            />
          </ScrollArea>
        </div>
      )}
      {config.rollingChart && (
        <div className="col-span-2">
          <RollingChart config={config.rollingChart} />
        </div>
      )}
      {config.flowChart && (
        <FlowChart fetcher={config.flowChart.fetcher} location={config.flowChart.location} />
      )}
      {config.gasChart && (
        <GasChart fetcher={config.gasChart.fetcher} location={config.gasChart.location} />
      )}
      {config.chartGroup && <KPIChartGroup request={config.chartGroup} />}
    </div>
  )
}
